
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"20","width":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.484 1.804l9.29 14.785c.301.523.301 1.125 0 1.607-.3.523-.86.804-1.462.804H1.732c-.646 0-1.205-.281-1.506-.804-.301-.482-.301-1.084 0-1.607l9.29-14.785c.301-.483.86-.804 1.506-.804.602 0 1.16.321 1.462.804z","fill":"#fde047"}}),_c('path',{attrs:{"d":"M1.46 16.842c-.085.129-.085.258-.085.387 0 .43.344.816.773.816h17.66c.43 0 .817-.387.817-.816a.693.693 0 00-.129-.387L11.86 2.018A1.032 1.032 0 0011 1.502c-.387 0-.73.215-.902.516zm-1.202-.688L8.895 1.33A2.472 2.472 0 0111 .127c.816 0 1.633.473 2.063 1.203l8.636 14.824c.172.301.301.688.301 1.074 0 1.204-.988 2.149-2.191 2.149H2.149A2.128 2.128 0 010 17.229c0-.387.086-.774.258-1.075zM11 5.627c.344 0 .688.344.688.687v5.5a.707.707 0 01-.688.688.679.679 0 01-.688-.688v-5.5c0-.343.301-.687.688-.687zm-1.031 9.625c0-.559.43-1.031 1.031-1.031.559 0 1.031.472 1.031 1.031 0 .601-.472 1.031-1.031 1.031-.602 0-1.031-.43-1.031-1.031z","fill":"#000"}})])
          )
        }
      }
    